import React from 'react';
import FeedbackBodyShimmer from './feedback-body-shimmer';
import ShimmerBlock from './shimmer-block';

// First load: the whole card as placeholders (header, body, footer).
const FeedbackShimmer = () => (
  <div className="h-full overflow-y-auto bg-gray-50">
    <div className="flex items-center justify-center min-h-full px-4 py-8">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
        <div className="flex items-center justify-between gap-3 px-5 py-3 bg-gray-50 border-b border-gray-100">
          <ShimmerBlock width="48px" height="24px" />
          <ShimmerBlock width="40%" height="14px" />
          <ShimmerBlock width="24px" height="24px" radius="50%" />
        </div>
        <FeedbackBodyShimmer />
        <div className="flex justify-center py-3 bg-gray-50 border-t border-gray-100">
          <ShimmerBlock width="110px" height="8px" />
        </div>
      </div>
    </div>
  </div>
);

export default FeedbackShimmer;
